// extracted by mini-css-extract-plugin
export default {"heading":"_v-z","corrected":"aw-z","redirectVerbiageContainer":"bw-z","redirectVerbiageText":"cw-z"};